import {Expose} from 'class-transformer';

export class ProgramEmailApiModel {
  @Expose()
  email: string;

  @Expose()
  redeemed: string;
}